import $ from 'jquery';

export default class {
  constructor(element) {
    this.element = element;
    this.$element = $(element);
    this.modify();
    this.ready();
  }

  modify() {
    // Transform the main destinations to play the video.
    const videoSrc = this.$element.find('.field-video a').eq(0).attr('href');
    this.$element.find('.node-header a, .link-read-more a').attr('href', videoSrc);
  }

  ready() {
    return this.$element.addClass('ready');
  }
}
